<template>
  <div class="compliance-notifications">
    <div class="section-title mb-15">
      {{ $t('text.compliance_notifications') }}
    </div>
    <div class="mb-5">{{ $t('text.receive_email_notifications') }}.</div>
    <div>
      <div>{{ $t('text.example') }}:</div>
      <ul>
        <li>
          {{
            $t('text.receive_email_desc1', {
              patients: $store.state.locale.patients
            })
          }}
        </li>
        <!-- <li>{{ $t('text.receive_email_desc2') }}</li> -->
      </ul>
    </div>
    <div>
      <el-checkbox
        v-model="receiveNotifications"
        @change="handleReceiveNotificationChange()"
      >
        {{ $t('text.i_want_to_receive_these_notifications') }}.
      </el-checkbox>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      receiveNotifications: false
    }
  },
  props: {
    showUserEmailSubscriptionStatusByDefault: {
      type: Boolean,
      default: false
    },
    emailInQuery: {
      // means come from email template
      type: String,
      default: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.showUserEmailSubscriptionStatusByDefault) {
        this.getUserEmailSubscription()
      }
    })
  },
  methods: {
    async getEmail() {
      let email = this.emailInQuery
        ? this.emailInQuery
        : this.$store.getters[`user/email`]
      if (!email) {
        const response = await ApiService.FetchUserDetails()
        email = response.data.data.Email
      }
      return email
    },
    async getUserEmailSubscription() {
      let email = await this.getEmail()
      ApiService.GetUserEmailSubscriptionByEmail(email)
        .then(response => {
          this.receiveNotifications = !!response.data.success
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    handleReceiveNotificationChange() {
      if (this.receiveNotifications) {
        this.subscribe()
      } else {
        this.unsubscribe()
      }
    },
    async subscribe() {
      let email = await this.getEmail()
      ApiService.SubscribeEventEmailByEmail(email)
        .then(response => {
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.subscribe_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    async unsubscribe() {
      let email = await this.getEmail()
      ApiService.UnSubscribeEventEmailByEmail(email)
        .then(response => {
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.unsubscribe_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
